import PaymentInstructionLayout from "../layouts/PaymentInstructionLayout";
import { useState } from "react";
import { Copy, Check, ChevronDown, ChevronUp } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
// import CountDownTimer from "./CountDownTimer";
// import formatCurrency from "../../utils/numberFormatter";
import METHOD_LOGOS from "./MethodLogos";
import useTranslation from "../hooks/useTranslation";

export default function PaymentInstructionQRIS({
  amount,
  orderId,
  merchantName,
  expired_at,
  selected_method,
  onCheckStatus,
  qrString,
}) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const [activeSection, setActiveSection] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(qrString);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const instructions = t("paymentInstructionQRIS.instructions");

  return (
    <PaymentInstructionLayout
      amount={amount}
      orderId={orderId}
      merchantName={merchantName}
      expiredAt={expired_at}
      selectedMethod={selected_method}
      onCheckStatus={onCheckStatus}
      paymentCredential={
        <div className="mt-4 mb-10 text-center">
          <div className="flex items-center gap-2 justify-center">
            <span className="font-bold">{t("paymentInstructionQRIS.pleaseScan")} </span>
            <img
              src={METHOD_LOGOS["QRIS"] || "/placeholder.svg"}
              className="h-12 w-12 object-contain"
              alt="QRIS Logo"
            />
          </div>
          <QRCodeSVG value={qrString} size={256} className="mx-auto rounded-lg" />
        </div>
      }
      howToPay={
        <div className="space-y-4 mt-6">
          <h3 className="text-xl font-bold">{t("paymentInstructionQRIS.howToPay")}</h3>
          <div className="border border-gray-200 rounded-lg overflow-hidden">
            <button
              className="w-full p-4 flex items-center justify-between bg-gray-50 hover:bg-gray-100"
              onClick={() => setActiveSection(!activeSection)}
            >
              <span className="font-medium">{t("paymentInstructionQRIS.stepByStep")}</span>
              {activeSection ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>
            {activeSection && (
              <div className="p-4 bg-white border-t border-gray-200">
                <ol className="list-inside space-y-2 text-gray-600">
                  {instructions.map((step, index) => (
                    <li key={index}>
                      {index + 1}. {step}
                    </li>
                  ))}
                </ol>
              </div>
            )}
          </div>
        </div>
      }
    />
  );
}
